import * as React from 'react';
import { FormField, Textarea } from '@cian/ui-kit';

import * as styles from './RequestFormModalContent.css';
import { IRegion, IRequestFormValues } from '../../../types/requestForm';
import { PhoneInput } from '../../PhoneInput';
import { RegionSuggest } from '../../RegionSuggest';

interface IRequestFormModalContentProps {
  onChange(values: Partial<IRequestFormValues>): void;
  onPhoneChange?(phone: string): void;
  onRegionSearch(text: string): Promise<IRegion[]>;
  onRequirementsChange?(): void;
  submitting: boolean;
  values: IRequestFormValues;
}

export const RequestFormModalContent: React.FC<IRequestFormModalContentProps> = ({
  onChange,
  onPhoneChange,
  onRegionSearch,
  onRequirementsChange,
  submitting,
  values,
}) => {
  const handlePhoneChange = React.useCallback(
    (value: string) => {
      onChange({ phone: value });

      if (onPhoneChange) {
        onPhoneChange(value);
      }
    },
    [onChange, onPhoneChange],
  );

  const handleRequirementsChange = React.useCallback(
    (_event: React.ChangeEvent, value: string) => {
      onChange({ requirements: value });

      if (onRequirementsChange) {
        onRequirementsChange();
      }
    },
    [onChange, onRequirementsChange],
  );

  const handleRegionChange = React.useCallback((value: IRegion | null) => onChange({ region: value }), [onChange]);

  return (
    <div data-testid="RequestFormModalContent">
      <div className={styles['row']}>
        <div className={styles['region-suggest-field-item']}>
          <FormField label="Где искать квартиру?" withoutMargin>
            <RegionSuggest
              disabled={submitting}
              onChange={handleRegionChange}
              onRegionSearch={onRegionSearch}
              value={values.region}
              name="region"
              placeholder="Выберите город"
              size="M"
            />
          </FormField>
        </div>
        <div className={styles['phone-field-item']}>
          <FormField label="Ваш номер телефона" withoutMargin>
            <PhoneInput disabled={submitting} onChange={handlePhoneChange} value={values.phone} name="phone" size="M" />
          </FormField>
        </div>
      </div>
      <div className={styles['row']}>
        <div className={styles['requirements-field-item']}>
          <FormField label="Напишите ваши пожелания" withoutMargin>
            <Textarea
              disabled={submitting}
              onChange={handleRequirementsChange}
              value={values.requirements}
              maxLength={300}
              maxRows={5}
              minRows={5}
              name="requirements"
              placeholder="Ищу новостройку с видом на парк..."
              size="M"
            />
          </FormField>
        </div>
      </div>
    </div>
  );
};
